export default __webpack_public_path__ + "static/media/hotel_icon.36e3a28e.png";